import SearchTab from './src/main';
/* istanbul ignore next */
SearchTab.install = function(Vue) {
    Vue.component(SearchTab.name, SearchTab);
};

export default SearchTab;
